import { useEffect, useState } from "react";
import { ID_RESULTADO_CONDICIONAL } from "../components/EnvioCreationContent";


export const useGetEnvioAnnouncement = (
    esComplejo,
    idResultadoPresupuesto,
    diasCO,
    maxDiasFacturacion,
    idEvaluacion,
    paciente,
    contratosC,
) => {
    const [envioAnnouncement, setEnvioAnnouncement] = useState(null);

    useEffect(() => {
        if (idResultadoPresupuesto === ID_RESULTADO_CONDICIONAL) {
            if (esComplejo) {
                if (diasCO > (maxDiasFacturacion * 0.25)) {
                    setEnvioAnnouncement(
                        `El pedido del contrato ${idEvaluacion} debe ser justificado para poder autorizarlo. El paciente ${paciente} y su(s) contrato(s) ${contratosC} anteriores cuentan con ${diasCO} días condicionales y supera el 25% de los días establecidos por el cliente (${maxDiasFacturacion} días).`
                    );
                } else {
                    setEnvioAnnouncement(
                        `El pedido del contrato ${idEvaluacion} NO debe ser justificado para poder autorizarlo. El contrato se encuentra en Condicional pero NO supera el 25% de los días establecidos por el cliente.`
                    );
                }
            } else {
                setEnvioAnnouncement(
                    `El contrato está en condicional y su tipo de módulo es no complejo. Por lo tanto, el envío no va a poder autorizarse hasta que no se apruebe dicho contrato.`
                );
            }
        } else {
            setEnvioAnnouncement(null);
        }
    }, [idResultadoPresupuesto, esComplejo, diasCO, maxDiasFacturacion, idEvaluacion, paciente, contratosC]);

    return { envioAnnouncement };
};
